export const PatientQuoteHeadshots = {
  patient1: 'e79115b4-a1e0-41cb-f775-459f079e3e00',
  patient2: 'e79115b4-a1e0-41cb-f775-459f079e3e00',
  patient3: 'a6771bb2-0aef-4b33-c437-bece75f78400',
  patient4: 'f27c5c1c-e8a4-4659-3061-f73a51f5fa00',
  patient5: '722007c5-ba89-4401-a961-766fb1d04000',
  patient6: 'fd30d34c-ade3-44a6-8695-e629775ae100',
  patient7: '9caf1001-ca5a-4a1f-a496-bfdc2ed6cc00',
  patient8: '131f7bdc-7bfc-4228-9518-4d23b2c6c600',
}
